import { useState } from "react";
import { useQuery } from "react-query";
//primeReact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
//components]
import Panel from "../../../components/panel/panel";
//services

import { Skeleton } from "primereact/skeleton";
import { Link } from "react-router-dom";
import { getConfigSign } from "../../../services/Enterprise/ClickSign/getConfigSign";
import { formatDate } from "../../../utils/formatDate";
import ModalCreateKey from "./ModalCreateKey";
import { getConfigWebhook } from "../../../services/Enterprise/ClickSign/getConfigWebhook";
import { toast } from "react-toastify";
import { useAppContext } from "../../../context/AppContext";

const ClickSignRegistrations = () => {
  const { permissions } = useAppContext();
  const items = [
    {
      template: () => (
        <Link to={`/settings/currentAccount`} className="p-breadcrumb-link">
          Cadastrar Chaves
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"/dashboard"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const [visible, setVisible] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [headerModal] = useState("Cadastrar");
  const [loading, setLoading] = useState(false); // Inicialmente, vazio

  const columns = [
    { field: "id", header: "ID" },
    {
      field: "name_token",
      header: "Nome do Token",
      body: (rowData) => `${rowData.name_token} - ${rowData.token_wallet_lote}`,
    },
    {
      field: "webhook",
      header: "Token de Integração",
      body: (rowData) =>
        rowData.webhook === 1 ? (
          <span className={`badge bg-success`}>Ativado</span>
        ) : (
          <span className={`badge bg-warning`}>Desativado</span>
        ),
    },
    {
      field: "created_at",
      header: "Criado em",
      body: (rowData) => formatDate(rowData.created_at),
    },
  ];
  const handleCloseModal = () => {
    setVisible(false);
  };

  async function SubmitResend(rowData) {
    setLoading(true);
    const configId = rowData.id;

    const notification = toast.loading(
      "Por favor, aguarde a ação está sendo realizada..."
    );

    try {
      const response = await getConfigWebhook(configId);

      if (response.error) {
        throw new Error(response.error.message);
      }

      toast.update(notification, {
        render: "Chave configurada com sucesso!",
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      toast.update(notification, {
        render: "Não foi possível cadastrar chave de integração!",
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    } finally {
      setLoading(false);
      refetch();
      setVisible(false);
    }
  }



  //get
  const {
    data: registeredIntegrations,
    refetch,
    isLoading,
  } = useQuery({
    queryKey: ["registeredIntegrations"],
    queryFn: () => getConfigSign(),
    enabled: !!permissions?.includes("166")
  });

  const hasWebhook = registeredIntegrations?.some((row) => row.webhook !== 1);

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className="col-xl-4 col-md-6">
          <BreadCrumb model={items} home={home} className="breadCrumb" />
        </div>
        <div className="col-xl-2 col-md-6">
          <Button
            loading={loading}
            rounded
            label="Nova Chave"
            icon="fa fa-plus"
            onClick={() => setVisible(true)}
            className="p-inputtext-sm me-2 m-auto w-100"
          />
        </div>
      </div>
      <Panel mainCss="mt-4" title="Chaves de Integração Cadastradas">
        {!registeredIntegrations ? (
          <Skeleton variant="rect" width="100%" height={300} />
        ) : (
          <>
            <div className="px-2 pb-3">
              <DataTable
                rows={5}
                paginator
                stripedRows
                showGridlines
                sortMode="multiple"
                selectionMode="single"
                rowsPerPageOptions={[5, 25, 100]}
                value={registeredIntegrations}
                totalRecords={registeredIntegrations}
                globalFilter={globalFilterValue}
                emptyMessage="Nenhuma Informação foi encontrada."
                tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
              >
                {columns.map((col) => (
                  <Column
                    sortable
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    body={col.body}
                  />
                ))}
                {hasWebhook && (
                  <Column
                    header="Reenviar"
                    body={(rowData) =>
                      rowData.webhook !== 1 ? (
                        <div className="text-center">
                          <button
                            disabled={loading}
                            className="btn btn-warning btn-sm"
                            onClick={(e) => SubmitResend(rowData)}
                          >
                            <i className="fa-solid fa-rotate-left"></i>
                          </button>
                        </div>
                      ) : null
                    }
                  />
                )}
              </DataTable>
            </div>
          </>
        )}
      </Panel>

      <ModalCreateKey
        visible={visible}
        headerModal={headerModal}
        handleCloseModal={handleCloseModal}
        setVisible={setVisible}
        refetch={refetch}
        loadingAccount={setLoading}
      />
    </>
  );
};

export default ClickSignRegistrations;
